import axios from 'axios';
import { getStoredToken } from './user-storage';
import store from '../services/store/configureStore';
import { setToken, setUserName } from './store/slices/user';
import { message } from 'antd';
// console.log(getStoredToken());
const { sid, username, email, api_key, api_secret } = getStoredToken() || {};

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    // "Cookie" :document.cookieMyApp,
    // token: 'Bearer ' + api_key + ':' + api_secret,
    Authorization: api_key ? `Token ${api_key}:${api_secret}` : '',
    // 'X-Frappe-CMD': '',
    // 'X-Frappe-Doctype': 'Item Group',
    // 'X-Requested-With': 'XMLHttpRequest',
    // "Cookie": `sid=${sid}; full_name=${username}; system_user=yes; user_id=${email}; user_image=`,
    // 'X-Frappe-CSRF-Token': sid,
  },
  withCredentials: true,
});
// axiosInstance.defaults.withCredentials = true;
axiosInstance.interceptors.request.use((config) => {
  const { sid, username, email, api_key, api_secret } = getStoredToken() || {};
  config.headers.Authorization = api_key
    ? `Token ${api_key}:${api_secret}`
    : '';
  if (config?.data instanceof FormData) {
    config.headers['Content-Type'] = 'multipart/form-data';
    // config.headers['Cookie'] = `sid=${sid}; full_name=${username}; system_user=yes; user_id=${email}; user_image=`;
  }
  // console.log('interceptors config:', config);
  return config;
});

axiosInstance.interceptors.response.use(null, (err) => {
  console.log('interceptors err:', err);
  // console.log('interceptors 222222:', err?.response);
  // console.log('interceptors 44444:', err?.config);
  const statusCode = err.response.status;
  if (statusCode === 401) {
    store.dispatch(setToken(null));
    store.dispatch(setUserName(null));
    localStorage.clear();
  }
  if(err?.response?.data?._server_messages){
    const serverMessages = JSON.parse(err?.response?.data?._server_messages);
    const messageData = JSON.parse(serverMessages[0]);
    console.log(messageData, 'messageData');
    
    const title = messageData.title || "Error";
    const messageContent = messageData.message || "An error occurred";
    message.error({
      content: `${title}: ${messageContent.replace(/<[^>]*>/g, "")}`,
      duration: 5,
    });
  }
  if (statusCode === 417) {
    return Promise.resolve();
  }
  if (err.name === 'AxiosError') {
    return Promise.reject(err);
  }
  // return err;
  return Promise.reject(err);
});
